import { FieldError } from 'react-hook-form';
import { IField, LabelStyle } from '../types';

export type SSNFieldProps = IField & {
  disabled?: boolean;
  helperText?: string;
  label?: string;
  labelStyle?: LabelStyle;
  last4only?: boolean;
  name: string;
  placeholder?: string;
};

// Internal only
export type SSNFieldControllerProps = {
  onBlur?: (...event: any) => void;
  onChange: (...event: any) => void;
  error: FieldError | undefined;
  value: any;
};

export const DEFAULT_HELPER_TEXT = '🔒 Encrypted and secure';
export const LAST_4_ONLY_PLACEHOLDER = 'Last 4 digits of SSN';
export const DEFAULT_PLACEHOLDER = 'xxx-xx-xxxx';
